import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Tabs": Tabs, "@mui/material/Tab": Tab, "@mui/icons-material/Phone": PhoneIcon, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/PersonPin": PersonPinIcon } } });
export default ClientProvider;
